import React from 'react';

const Section1 = () => {
    return (
        <div className='bg-pic-1 bg-cover'>
            <div className='w-11/12 mx-auto py-36'>
                <h2 className='md:text-7xl text-4xl font-extrabold text-primary-600'>ALL THE ANSWERS. <br /> NONE OF THE FLUFF.</h2>
                <p className='text-xl my-5'>Concise, Actionable Medical & Drug Information Resources</p>
                <button className='text-2xl font-bold text-white bg-red-500 hover:bg-red-600 px-6 py-2 rounded-full'>VIEW FEATURES</button><br /><br />
                <button className='text-2xl font-bold text-white bg-red-500 hover:bg-red-600 px-6 py-2 rounded-full'>SUBSCRIBE</button>
            </div>
        </div>
    );
};

export default Section1;